import { FormSection } from '../ui/FormSection';

export interface EventContactFieldsProps {
  contactEmail: string;
  onContactEmailChange: (value: string) => void;
  contactPhone: string;
  onContactPhoneChange: (value: string) => void;
  isSubmitting: boolean;
}

export const EventContactFields = ({
  contactEmail,
  onContactEmailChange,
  contactPhone,
  onContactPhoneChange,
  isSubmitting,
}: EventContactFieldsProps) => (
  <FormSection title="Contact Information">
    {/* Contact Email */}
    <div>
      <label htmlFor="contactEmail" className="block text-sm font-medium text-gray-700 mb-1">
        Contact Email
      </label>
      <input
        id="contactEmail"
        type="email"
        value={contactEmail}
        onChange={(e) => onContactEmailChange(e.target.value)}
        disabled={isSubmitting}
        placeholder="contact@example.com"
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
          isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
      />
    </div>

    {/* Contact Phone */}
    <div>
      <label htmlFor="contactPhone" className="block text-sm font-medium text-gray-700 mb-1">
        Contact Phone
      </label>
      <input
        id="contactPhone"
        type="tel"
        value={contactPhone}
        onChange={(e) => onContactPhoneChange(e.target.value)}
        disabled={isSubmitting}
        placeholder="(555) 123-4567"
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
          isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
      />
    </div>
  </FormSection>
);
